import { Application } from '@hotwired/stimulus'

const application = Application.start()
application.debug = false
window.Stimulus = application

// Eager-load every Stimulus controller in this directory.
const controllers = import.meta.glob('./*_controller.js', { eager: true })
for (const path in controllers) {
  const identifier = path
    .replace(/^\.\//, '')
    .replace(/_controller\.js$/, '')
    .replace(/_/g, '-')
  application.register(identifier, controllers[path].default)
}

export { application }
